import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';
import startIcon from '../../assets/startIcon.svg';
import type { AutoplayButtonProps } from '../base/AutoplayButton';
import { AutoplayButton } from '../base/AutoplayButton';

import styles from './AutoplayStartButton.module.css';

export interface AutoplayStartButtonProps extends AutoplayButtonProps {
  count: number;
  totalBet: ReactElement | string;
}

export const AutoplayStartButton: FC<AutoplayStartButtonProps> = ({ count, totalBet, className, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayStartBtn', {}, { withBaseClass: true, extraClassName: className });

  return (
    <AutoplayButton className={mods} {...rest}>
      <div data-testid="autoplay-start-button" className={styles.autoplayStartBtn__content}>
        <div className={styles.autoplayStartBtn__info}>
          <span data-testid={`autoplay-start-button-${count}`} className={styles.autoplayStartBtn__count}>{count}</span>
          <span className={styles.autoplayStartBtn__label}>
            <L10nText tk="ROUNDS" />
          </span>
        </div>
        <div className={styles.autoplayStartBtn__total}>
          <L10nText tk="TOTAL" />
          {': '}
          <span data-testid="autoplay-total-bet" className={styles.autoplayStartBtn__totalBet}>{totalBet}</span>
        </div>
      </div>
      <img className={styles.autoplayStartBtn__icon} src={startIcon} alt="start-icon" />
    </AutoplayButton>
  );
};
